module.exports = __webpack_public_path__ + "static/media/Products.75fb196c.svg";